import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { makeEnvironmentProviders } from '@angular/core';
import { AuthInterceptor, LogLevel, provideAuth, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';

export interface ShareViewAuthorizationProviderConfig {
  issuer: string;
  clientId: string;
  scope: string;
  secureRoutes: string[];
}

export const provideShareViewAuthorization = ({
  issuer,
  clientId,
  scope,
  secureRoutes,
}: ShareViewAuthorizationProviderConfig) =>
  makeEnvironmentProviders([
    provideAuth(
      {
        config: {
          authority: issuer,
          redirectUrl: `${window.location.origin}/callback`,
          postLogoutRedirectUri: window.location.origin,
          clientId: clientId,
          scope: scope,
          responseType: 'code',
          // Fall back when WebCrypto is unavailable (e.g., some iOS/HTTP contexts).
          disablePkce: !window.crypto?.subtle,
          silentRenew: false,
          useRefreshToken: true,
          logLevel: LogLevel.Warn,
          secureRoutes: secureRoutes,
          customParamsEndSessionRequest: {
            client_id: clientId,
          },
          unauthorizedRoute: '/',
          forbiddenRoute: '/',
        },
      },
      withAppInitializerAuthCheck()
    ),
    { provide: HTTP_INTERCEPTORS, multi: true, useClass: AuthInterceptor },
  ]);
